export const MASTERCLASS_SORT_OPTIONS = [
  { key: 'default', label: 'По умолчанию' },
  { key: 'priceDSC', label: 'По цене ↓' },
  { key: 'priceASC', label: 'По цене ↑' },
  { key: 'reviewsDSC', label: 'По количеству отзывов' },
  { key: 'purchasesDSC', label: 'По популярности' },
] as const;

export type MasterclassSortKey =
  (typeof MASTERCLASS_SORT_OPTIONS)[number]['key'];
